export const personalData = [
  {
    label: 'Name',
    value: 'Andrew McInally'
  },
  {
    label: 'Age',
    value: '38'
  },
  {
    label: 'Address',
    value: 'Aspen, CO'
  },
  {
    label: 'Email',
    value: 'realfunnyestate@yahoo.com'
  },
  {
    label: 'Contact No',
    value: '(805)216-1550'
  },
]